export default __webpack_public_path__ + "static/media/RhymesWeather_12.9ec4617a.png";